import { render, staticRenderFns } from "./ShowPage.vue?vue&type=template&id=3d5ee3db&scoped=true&"
import script from "./js/showPage.js?vue&type=script&lang=js&"
export * from "./js/showPage.js?vue&type=script&lang=js&"
import style0 from "./ShowPage.vue?vue&type=style&index=0&id=3d5ee3db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5ee3db",
  null
  
)

export default component.exports